<div class="calendar {{ className }} position-relative" [class.embed]="variant === 'embed'">
    <loading [loading]="loading" [hasData]="true" [parentWrapped]="true"></loading>
    <full-calendar [options]="calendarOptions"></full-calendar>
</div>

<p-dialog
    [(visible)]="showDetailsModal" [contentStyle]="{'max-height': '600px', 'overflow': 'auto'}"
    [modal]="true"
    [style]="{'width':'fit-content', 'max-width': '80vw'}">

    <ng-template pTemplate="header" class="pb-1">
        <h2 class="mb-0">
            {{ (selectedDate ?? '') | dateLocale:"dd MMMM" }}
            <div class="separator secondary d-flex align-items-center mt-3">
                <span></span>
                <i class="fa-solid fa-ellipsis mx-2"></i>
            </div>
        </h2>
    </ng-template>

    <ng-template pTemplate>
        <ng-container *ngFor="let event of eventsForDate; let index = index">
            <div class="event-description row d-nowrap" [class.py-4]="eventsForDate?.length <= 2">
                <div class="my-1 col-6 mx-0">
                    <div class="pe-3">
                        <strong class="event-title">{{ event.title }}:</strong>
                        <p class="mb-0 me-1">
                            <a [routerLink]="'/groups/' + event?.details?.id" [title]="'Към курса' | transloco">
                                {{ event?.details?.course?.title }}
                            </a>
                        </p>
                    </div>

                    <div class="btn-group position-absolute actions-dropdown" *ngIf="mode === 'edit'">
                        <button class="btn btn-default btn-sm dropdown-toggle no-caret py-0"
                                type="button"
                                data-bs-boundary="document"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                        >
                            <i class="fa-solid fa-gear fa-fw fa-lg"></i>
                        </button>

                        <ul class="dropdown-menu">
                            <li>
                                <button type="button" class="dropdown-item" (click)="onEdit($event, event)">
                                    <i class="fa-solid fa-pen-to-square fa-fw"></i>
                                    {{ 'Редактиране' | transloco }}
                                </button>
                            </li>
                            <li><hr class="dropdown-divider"></li>
                            <li>
                                <button type="button" class="dropdown-item" (click)="onDelete($event, event)">
                                    <i class="fas fa-trash-can fa-fw text-danger"></i>
                                    {{ 'Премахване' | transloco }}
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="clock col-6 mx-0">
                    <div class="circle">
                        <i class="icon icon-event-clock"></i>
                    </div>

                    <span class="badge rounded-pill text-bg-primary">
                        {{ event.start | dateLocale:'HH:mm' }} - {{ event.end | dateLocale:'HH:mm'  }}
                    </span>
                </div>
            </div>
            <hr class="divider" *ngIf="(index + 1) != eventsForDate.length">
        </ng-container>
    </ng-template>

    <ng-template pTemplate="footer" *ngIf="mode === 'edit'" >
        <button type="button" class="btn btn-primary btn-sm" (click)="onAdd($event)">
            <i class="fas fa-plus fa-fw"></i>
            {{ 'Добави друго събитие' | transloco}}
        </button>
    </ng-template>
</p-dialog>

<modal-confirm *ngIf="showDeleteConfirm"
               [headline]="'Премахване на събитие' | transloco"
               [body]="'Желаете ли да премахнете това събитие?' | transloco"
               [skippable]="true"
               (onAction)="onDeleteConfirmed($event)"
>
    <p-multiSelect *ngIf="otherEvents?.length"
                    class="mt-4 mb-4 d-block"
                    [(ngModel)]="selectedOtherEvents"
                    [options]="otherEvents || []"
                    optionLabel="title"
                    optionValue="id"
                    appendTo="body"

                    [defaultLabel]="'Други събития в групата за изтриване?' | transloco"
                    [emptyFilterMessage]="'Няма намерени резултати' | transloco"
                    [emptyMessage]="'Няма намерени резултати' | transloco"
    >
        <ng-template let-event pTemplate="item">
            <div class="d-flex align-items-start flex-column overflow-hidden text-truncate">
                {{ event.title ?? '' }}
                <small class="text-muted">{{ event.start | dateLocale:"short"}} - {{ event.end | dateLocale:"short"}}</small>
            </div>
        </ng-template>
    </p-multiSelect>
</modal-confirm>
